import FieldWrapper from 'components/FieldWrapper';
import Creatable from 'react-select/creatable';
import {Props as SelectProps} from 'components/Select';
import classNames from 'classnames';
import '../Select/Select.scss';
interface Props extends Omit<SelectProps, 'size'> {
  label?: string;
  error?: string;
  size?: 'sm' | 'md' | 'lg';
  onCreateOption?: (inputValue: string) => void;
}

function CreatableSelect({
  label,
  error,
  size = 'md',
  className,
  ...restProps
}: Props) {
  return (
    <FieldWrapper label={label} error={error}>
      <Creatable
        isClearable
        classNamePrefix="Select"
        className={classNames(`Select-${size}`, !!error && 'error', className)}
        {...restProps}
      />
    </FieldWrapper>
  );
}

export default CreatableSelect;
